import { UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu } from "antd";
import { Link } from "react-router-dom";
import logoSvg from "../../pages/authenticatedApp/backoffice/logo.svg";
import routes from "../../../routes";
import { useAuth } from "../../contexts/auth";
import "./style.css";

const LabsTopMenu = () => {
  const auth = useAuth();
  const user = auth.loggedInUser;
  const userRole = user?.role;
  const onClick = (e) => {
    const { key } = e;
    switch (key) {
      case "logout":
        return auth.logout();
      default:
        console.log("no handler");
        break;
    }
  };

  const menu = (
    <Menu onClick={onClick}>
      <Menu.Item key="logout">Logout</Menu.Item>
    </Menu>
  );

  return (
    <div className="labsMenuContainer">
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Link to={routes.backOffice.dashboard_new.view} className="labLogo">
          <img
            src={logoSvg}
            alt="Logo"
            style={{ height: "32px", width: "auto", cursor: "pointer" }}
          />
        </Link>
        <div className="labMenuOption">
          {userRole === "lab_admin" ? (
            <Link to={routes.labs.labDashboard.view} className="labMenuItem">
              Dashboard
            </Link>
          ) : null}

          {userRole === "lab_admin" ? (
            <Link
              to={
                userRole !== "lab_admin"
                  ? routes.backOffice.dashboard_new.view
                  : routes.labs.dashboard
              }
              className="labMenuItem"
            >
              Orders
            </Link>
          ) : (
            <></>
          )}

          <Link to={routes.labs.reviewReports.list} className="labMenuItem">
            Review Reports
          </Link>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          height: "100%",
          paddingRight: 20,
        }}
      >
        <div style={{ padding: "0 20px" }}>
          <a
            href="https://portal-help.foodlabz.ai/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span style={{ color: "#fff" }}>Help Centre</span>
          </a>
        </div>
        <div style={{ padding: "0 20px" }}>
          <span style={{ color: "#fff", cursor: "context-menu" }}>
            Hello, {user.firstName}!
          </span>
        </div>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button
            onClick={(e) => e.preventDefault()}
            type="secondary"
            shape="circle"
            icon={<UserOutlined />}
          />
        </Dropdown>
      </div>
    </div>
  );
};

export default LabsTopMenu;
